(function() {
'use strict';

// ========== DEBUG SYSTEM ==========
// Konsola debug logları görmek için: window.EFX_DEBUG = true
var EFX_DEBUG = false;

// ========== SOURCE IDENTIFIER ==========
var WHEEL_SOURCE = 'inline';

var DEBUG_PREFIX = '%c[EFX-WHEEL-DEBUG]';
var DEBUG_STYLE = 'color:#d4af37;font-weight:bold;';
var DEBUG_STYLE_WARN = 'color:#e74c3c;font-weight:bold;';
var DEBUG_STYLE_OK = 'color:#2ecc71;font-weight:bold;';

function isDebug() { return EFX_DEBUG || window.EFX_DEBUG; }

function dbg(msg, data) {
    if (!isDebug()) return;
    if (data !== undefined) { console.log(DEBUG_PREFIX + ' ' + msg, DEBUG_STYLE, data); }
    else { console.log(DEBUG_PREFIX + ' ' + msg, DEBUG_STYLE); }
}
function dbgWarn(msg, data) {
    if (!isDebug()) return;
    if (data !== undefined) { console.log(DEBUG_PREFIX + ' ⚠️ ' + msg, DEBUG_STYLE_WARN, data); }
    else { console.log(DEBUG_PREFIX + ' ⚠️ ' + msg, DEBUG_STYLE_WARN); }
}
function dbgOk(msg, data) {
    if (!isDebug()) return;
    if (data !== undefined) { console.log(DEBUG_PREFIX + ' ✅ ' + msg, DEBUG_STYLE_OK, data); }
    else { console.log(DEBUG_PREFIX + ' ✅ ' + msg, DEBUG_STYLE_OK); }
}

dbg('========================================');
dbg('   EFX Gift Wheel - DEBUG MODE AKTIF   ');
dbg('========================================');
dbg('Sayfa yüklendi: ' + window.location.href);
dbg('Zaman: ' + new Date().toISOString());

// ========== PROXY ==========
async function sendToProxy(payload) {
    dbg('📡 Proxy isteği gönderiliyor → action: ' + payload.action, payload);
    try {
        var r = await fetch('/apps/efx-mila', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
        });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        var json = await r.json();
        dbg('📡 Proxy yanıtı ← action: ' + payload.action, json);
        return json;
    } catch (e) {
        dbgWarn('📡 Proxy HATA ← action: ' + payload.action + ' → ' + e.message);
        return null;
    }
}

// ========== COOKIE SYSTEM ==========
var COOKIE_NAME = 'efx_wheel_used';
var COOKIE_DAYS = 15;

var DISMISS_COOKIE_NAME = 'efx_wheel_dismissed';
var DISMISS_COOKIE_DAYS = 3;

var SPUN_COOKIE_NAME = 'efx_wheel_spun';
var SPUN_COOKIE_DAYS = 1;

var COOKIE_EXPIRY_SUFFIX = '_exp';

function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires + ';path=/;SameSite=Lax';
    dbg('🍪 Cookie SET → ' + name + '=' + value + ' (süre: ' + days + ' gün, bitiş: ' + expires + ')');
}

function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}

function setCookieWithExpiry(name, value, days) {
    setCookie(name, value, days);
    var expiryMs = Date.now() + days * 24 * 60 * 60 * 1000;
    setCookie(name + COOKIE_EXPIRY_SUFFIX, String(expiryMs), days);
}

function getCookieExpiry(name) {
    var val = getCookie(name + COOKIE_EXPIRY_SUFFIX);
    return val ? parseInt(val, 10) : null;
}

function hasUsedWheel() {
    var val = getCookie(COOKIE_NAME) === '1';
    dbg('🍪 hasUsedWheel() → ' + val);
    return val;
}

function markWheelUsed() {
    dbg('🍪 markWheelUsed() çağrıldı');
    setCookieWithExpiry(COOKIE_NAME, '1', COOKIE_DAYS);
}

function hasBeenDismissed() {
    var val = getCookie(DISMISS_COOKIE_NAME) === '1';
    dbg('🍪 hasBeenDismissed() → ' + val);
    return val;
}

function markDismissed() {
    dbg('🍪 markDismissed() çağrıldı');
    setCookieWithExpiry(DISMISS_COOKIE_NAME, '1', DISMISS_COOKIE_DAYS);
}

function hasSpunWheel() {
    var val = getCookie(SPUN_COOKIE_NAME) === '1';
    dbg('🍪 hasSpunWheel() → ' + val);
    return val;
}

function markWheelSpun() {
    dbg('🍪 markWheelSpun() çağrıldı');
    setCookieWithExpiry(SPUN_COOKIE_NAME, '1', SPUN_COOKIE_DAYS);
}

// ========== TIMER SYSTEM ==========

function getRemainingMs(blockedReason, ipExpiryMs) {
    dbg('⏱️ getRemainingMs() → reason: ' + blockedReason + ', ipExpiryMs: ' + ipExpiryMs);

    if (blockedReason === 'ip_blocked' && ipExpiryMs) {
        var remaining = Math.max(0, ipExpiryMs - Date.now());
        dbg('⏱️ IP blocked → kalan: ' + remaining + 'ms (~' + Math.round(remaining/3600000) + ' saat)');
        return remaining;
    }
    var cookieName = null;
    var fallbackDays = 1;
    if (blockedReason === 'used') { cookieName = COOKIE_NAME; fallbackDays = COOKIE_DAYS; }
    else if (blockedReason === 'spun') { cookieName = SPUN_COOKIE_NAME; fallbackDays = SPUN_COOKIE_DAYS; }
    else if (blockedReason === 'dismissed') { cookieName = DISMISS_COOKIE_NAME; fallbackDays = DISMISS_COOKIE_DAYS; }

    if (cookieName) {
        var expiry = getCookieExpiry(cookieName);
        if (expiry) {
            var rem = Math.max(0, expiry - Date.now());
            dbg('⏱️ Cookie expiry bulundu → kalan: ' + rem + 'ms (~' + Math.round(rem/3600000) + ' saat)');
            return rem;
        }
        var fallbackMs = fallbackDays * 24 * 60 * 60 * 1000;
        dbgWarn('⏱️ Cookie expiry YOK → fallback: ' + fallbackDays + ' gün');
        setCookie(cookieName + COOKIE_EXPIRY_SUFFIX, String(Date.now() + fallbackMs), fallbackDays);
        return fallbackMs;
    }
    if (blockedReason === 'ip_blocked') {
        dbgWarn('⏱️ IP blocked ama ipExpiryMs yok → 24 saat fallback');
        return 24 * 60 * 60 * 1000;
    }
    return 0;
}

function formatTimeUnit(val) {
    return val < 10 ? '0' + val : String(val);
}

function buildTimerHtml(remainingMs, texts) {
    var totalSec = Math.max(0, Math.floor(remainingMs / 1000));
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);
    var secs = totalSec % 60;

    var timerTitle = getText(texts, 'timer_title');
    var timerSubtitle = getText(texts, 'timer_subtitle');

    var showDays = days > 0;

    var html =
        '<div class="efxIlTimerWrap">' +
            '<div class="efxIlTimerIcon">⏳</div>' +
            '<h3 class="efxIlTimerTitle">' + timerTitle + '</h3>' +
            '<p class="efxIlTimerSubtitle">' + timerSubtitle + '</p>' +
            '<div class="efxIlTimerBoxes" data-el="timerBoxes">' +
                (showDays ? '<div class="efxIlTimerBox"><span class="efxIlTimerNum" data-timer="days">' + formatTimeUnit(days) + '</span><span class="efxIlTimerLabel">' + getText(texts, 'timer_days') + '</span></div><span class="efxIlTimerSep">:</span>' : '') +
                '<div class="efxIlTimerBox"><span class="efxIlTimerNum" data-timer="hours">' + formatTimeUnit(hours) + '</span><span class="efxIlTimerLabel">' + getText(texts, 'timer_hours') + '</span></div>' +
                '<span class="efxIlTimerSep">:</span>' +
                '<div class="efxIlTimerBox"><span class="efxIlTimerNum" data-timer="mins">' + formatTimeUnit(mins) + '</span><span class="efxIlTimerLabel">' + getText(texts, 'timer_mins') + '</span></div>' +
                '<span class="efxIlTimerSep">:</span>' +
                '<div class="efxIlTimerBox"><span class="efxIlTimerNum" data-timer="secs">' + formatTimeUnit(secs) + '</span><span class="efxIlTimerLabel">' + getText(texts, 'timer_secs') + '</span></div>' +
            '</div>' +
        '</div>';
    return html;
}

function startTimerCountdown(container, endTimeMs, texts) {
    var interval = setInterval(function() {
        var remaining = Math.max(0, endTimeMs - Date.now());
        var totalSec = Math.floor(remaining / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        var secs = totalSec % 60;

        var daysEl = container.querySelector('[data-timer="days"]');
        var hoursEl = container.querySelector('[data-timer="hours"]');
        var minsEl = container.querySelector('[data-timer="mins"]');
        var secsEl = container.querySelector('[data-timer="secs"]');

        if (days > 0 && !daysEl) {
            var boxesEl = container.querySelector('[data-el="timerBoxes"]');
            if (boxesEl) {
                var dayBox = document.createElement('div');
                dayBox.className = 'efxIlTimerBox';
                dayBox.innerHTML = '<span class="efxIlTimerNum" data-timer="days">' + formatTimeUnit(days) + '</span><span class="efxIlTimerLabel">' + getText(texts, 'timer_days') + '</span>';
                var sep = document.createElement('span');
                sep.className = 'efxIlTimerSep';
                sep.textContent = ':';
                boxesEl.insertBefore(sep, boxesEl.firstChild);
                boxesEl.insertBefore(dayBox, boxesEl.firstChild);
                daysEl = dayBox.querySelector('[data-timer="days"]');
            }
        }

        if (daysEl) daysEl.textContent = formatTimeUnit(days);
        if (hoursEl) hoursEl.textContent = formatTimeUnit(hours);
        if (minsEl) minsEl.textContent = formatTimeUnit(mins);
        if (secsEl) secsEl.textContent = formatTimeUnit(secs);

        if (remaining <= 0) {
            clearInterval(interval);
            window.location.reload();
        }
    }, 1000);
    return interval;
}

// ========== DEFAULT TEXTS ==========
var DEFAULT_TEXTS = {
    main_title: 'Çarkı çevir, ödülünü kap!',
    main_subtitle: 'Üye ol, kodun anında gelsin. Kampanyalar için izinlerini seçebilirsin.',
    form_title: 'Üye Ol & Kuponu Al',
    form_subtitle: 'Bilgilerini gir, izinlerini seç, ödülünü gönderelim.',
    btn_spin: 'ÇEVİR',
    btn_submit_before_spin: 'Çarkı Çevir',
    btn_submit_after_spin: 'Ödülü Al',
    btn_submitting: 'Gönderiliyor...',
    btn_verify: 'Doğrula',
    btn_verifying: 'Doğrulanıyor...',
    btn_resend: 'Tekrar Gönder',
    btn_copy: 'Kopyala',
    btn_copied: 'Kopyalandı!',
    btn_completed: 'İşlem Tamamlandı',
    btn_limit_exceeded: 'Limit Aşıldı',
    win_label: 'Kazandın!',
    win_congrats: 'Tebrikler!',
    win_mobile_prefix: 'Tebrikler! Kazandın:',
    label_email: 'E-posta',
    label_phone: 'Telefon',
    placeholder_email: 'ornek@mail.com',
    placeholder_phone: '5XX XXX XX XX',
    phone_prefix: '+90',
    checkbox_kvkk_info: 'Kişisel verileriniz, <a href="{kvkk_url}" target="_blank">Müşteri Aydınlatma Metni</a> kapsamında işlenmektedir.',
    checkbox_marketing: 'Kampanya ve duyurulardan haberdar olmak istiyorum. {company_name} tarafıma ticari elektronik ileti göndermesine izin veriyorum. <a href="{marketing_url}" target="_blank">Detaylı bilgi</a>',
    checkbox_membership: '<a href="{membership_url}" target="_blank">Üyelik sözleşmesini</a> okudum, onaylıyorum.',
    checkbox_consent: 'Kişisel verilerimin <a href="{consent_url}" target="_blank">Açık Rıza Metni</a> uyarınca işlenmesini kabul ediyorum.',
    sms_title: '📱 SMS Doğrulama',
    sms_info: 'Telefonunuza gönderilen 6 haneli kodu girin',
    sms_placeholder: '• • • • • •',
    sms_success: 'Yeni kod gönderildi!',
    error_email: 'Geçerli bir e-posta adresi girin',
    error_phone: 'Geçerli bir telefon numarası girin (5XX ile başlamalı)',
    error_membership: 'Üyelik sözleşmesini onaylamalısınız',
    error_consent: 'Açık rıza metnini onaylamalısınız',
    error_sms_code: '6 haneli doğrulama kodunu girin',
    error_sms_send: 'SMS gönderilemedi. Lütfen tekrar deneyin.',
    error_sms_verify: 'Doğrulama kodu hatalı.',
    copy_success: 'Kopyalandı ✓',
    phone_conflict_message: 'Telefon numaranız başka bir kullanıcıda tanımlı.',
    support_link_text: 'Destek Ekibiyle İletişime Geç',
    reward_free_shipping: 'Ücretsiz Kargo',
    reward_fixed_amount_suffix: 'TL İndirim',
    reward_percent_prefix: '%',
    reward_percent_suffix: 'İndirim',
    url_kvkk: 'https://milagron.com/pages/kvkk',
    url_marketing: 'https://milagron.com/pages/ticari-elektronik-ileti-onay-metni',
    url_membership: 'https://milagron.com/pages/uyelik-sozlesmesi',
    url_consent: 'https://milagron.com/pages/kvkk',
    url_support: 'https://milagron.com/pages/iletisim',
    company_name: 'Milagron.com Elektronik Hizmetleri A.Ş.\'nin',
    already_used_title: 'Çarkı zaten çevirdiniz!',
    already_used_subtitle: 'Hediye çarkını daha önce kullandınız. 15 gün sonra tekrar deneyebilirsiniz.',
    ip_blocked_message: 'Yakın zamanda çarkı çevirdin, daha sonra tekrar dene 🎡',
    timer_title: 'Çevirme hakkını kullandın',
    timer_subtitle: 'Sayaç sıfırlandığında yeni hediyeni almak için tekrar çevirebilirsin.',
    timer_days: 'Gün',
    timer_hours: 'Saat',
    timer_mins: 'Dakika',
    timer_secs: 'Saniye',
};

// ========== DEFAULT COLORS ==========
var DEFAULT_COLORS = {
    accent: '#d4af37',
    accent_hover: '#b8952f',
    btn_text: '#ffffff',
    center_btn_bg: '#1a1a1a',
    center_btn_border: '#d4af37',
    pointer_color: '#d4af37',
    win_reward_color: '#d4af37',
    success_color: '#16a34a',
    error_color: '#dc2626',
    segment_colors: '#E53935,#FF9800,#8BC34A,#00BCD4,#3F51B5,#9C27B0,#F44336,#4CAF50,#2196F3,#FFEB3B',
};

function getText(texts, key) { return (texts && texts[key]) || DEFAULT_TEXTS[key] || ''; }
function getColor(colors, key) { return (colors && colors[key]) || DEFAULT_COLORS[key] || ''; }

function hexToRgb(hex) {
    hex = (hex || '').replace('#', '');
    if (hex.length !== 6) return '212,175,55';
    return [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16)].join(',');
}

function processText(texts, key) {
    var text = getText(texts, key);
    text = text.replace(/\{kvkk_url\}/g, getText(texts, 'url_kvkk'));
    text = text.replace(/\{marketing_url\}/g, getText(texts, 'url_marketing'));
    text = text.replace(/\{membership_url\}/g, getText(texts, 'url_membership'));
    text = text.replace(/\{consent_url\}/g, getText(texts, 'url_consent'));
    text = text.replace(/\{support_url\}/g, getText(texts, 'url_support'));
    text = text.replace(/\{company_name\}/g, getText(texts, 'company_name'));
    return text;
}

function pickWeighted(segments) {
    var total = 0;
    for (var i = 0; i < segments.length; i++) { var w = parseInt(segments[i].weight || 0, 10) || 0; if (w > 0) total += w; }
    if (total <= 0) { var idx = Math.floor(Math.random() * segments.length); return { seg: segments[idx], index: idx, total: segments.length }; }
    var r = Math.random() * total;
    for (var i = 0; i < segments.length; i++) { var w = parseInt(segments[i].weight || 0, 10) || 0; if (w <= 0) continue; r -= w; if (r <= 0) return { seg: segments[i], index: i, total: total }; }
    return { seg: segments[segments.length - 1] || null, index: segments.length - 1, total: total };
}

// ========== IP CHECK ==========
async function checkIpAllowed(wheelId) {
    dbg('🌐 checkIpAllowed() → wheelId: ' + wheelId);
    try {
        var res = await sendToProxy({ action: 'checkIpLimit', wheelId: wheelId || null, source: WHEEL_SOURCE, ts: Date.now() });
        if (!res) { dbgOk('🌐 checkIpAllowed → null yanıt, izin veriliyor'); return { allowed: true }; }
        if (res.allowed) { dbgOk('🌐 checkIpAllowed → İZİN VERİLDİ'); }
        else { dbgWarn('🌐 checkIpAllowed → ENGELLENDİ! reason: ' + res.reason + ', expires_at: ' + res.expires_at); }
        return { allowed: !!res.allowed, reason: res.reason || null, expires_at: res.expires_at || null };
    } catch (e) { dbgWarn('🌐 checkIpAllowed → HATA: ' + e.message); return { allowed: true }; }
}

async function checkIpSpin(wheelId) {
    dbg('🌐 checkIpSpin() → wheelId: ' + wheelId);
    try {
        var res = await sendToProxy({ action: 'checkIpSpin', wheelId: wheelId || null, source: WHEEL_SOURCE, ts: Date.now() });
        if (!res) { dbgOk('🌐 checkIpSpin → null yanıt, izin veriliyor'); return { allowed: true }; }
        if (res.allowed) { dbgOk('🌐 checkIpSpin → İZİN VERİLDİ'); }
        else { dbgWarn('🌐 checkIpSpin → ENGELLENDİ! reason: ' + res.reason); }
        return { allowed: !!res.allowed, reason: res.reason || null, expires_at: res.expires_at || null };
    } catch (e) { dbgWarn('🌐 checkIpSpin → HATA: ' + e.message); return { allowed: true }; }
}

function injectTimerCSS() {}

// ========== INLINE RENDER ==========
function renderInline(wheel, blockedReason, ipExpiryMs) {
    dbg('🎨 renderInline() → blockedReason: ' + (blockedReason || 'YOK') + ', ipExpiryMs: ' + (ipExpiryMs || 'YOK'));

    var container = document.getElementById('efxGwInlineContainer');
    if (!container) return;

    var T = wheel.texts || {};
    var C = wheel.colors || {};
    var txt = function(key) { return getText(T, key); };
    var txtP = function(key) { return processText(T, key); };
    var clr = function(key) { return getColor(C, key); };
    var esc = function(s) { return String(s || '').replace(/[&<>"']/g, function(c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[c]; }); };

    var accent = clr('accent'), accentHover = clr('accent_hover'), btnText = clr('btn_text');
    var centerBtnBg = clr('center_btn_bg'), centerBtnBorder = clr('center_btn_border');
    var pointerColor = clr('pointer_color'), winRewardColor = clr('win_reward_color');
    var successColor = clr('success_color'), errorColor = clr('error_color');
    var segmentColorsStr = clr('segment_colors');
    var segmentColorArr = segmentColorsStr.split(',').map(function(c) { return c.trim(); }).filter(Boolean);
    var accentRgb = hexToRgb(accent);

    var segs = Array.isArray(wheel.segments) ? wheel.segments : [];
    var sliceCount = Math.max(1, segs.length);
    var sliceDeg = 360 / sliceCount;
    var isMobile = window.innerWidth <= 768;
    var size = isMobile ? 280 : 380;

    var wheelImageUrl = wheel.wheel_image || null, pointerImageUrl = wheel.pointer_image || null, buttonImageUrl = wheel.button_image || null, backgroundImageUrl = wheel.background_image || null;
    var hasCustomImage = !!wheelImageUrl, hasCustomPointer = !!pointerImageUrl, hasCustomButton = !!buttonImageUrl;

    var diskStyle = '', labelsHtml = '';

    if (hasCustomImage) {
        diskStyle = "background-image:url('" + wheelImageUrl + "');background-size:cover;background-position:center;background-repeat:no-repeat;";
    } else {
        var cx = size / 2, cy = size / 2, outerR = (size / 2) - 2;
        var colors = segmentColorArr.length > 0 ? segmentColorArr : ['#E53935', '#FF9800', '#8BC34A', '#00BCD4', '#3F51B5', '#9C27B0', '#F44336', '#4CAF50', '#2196F3', '#FFEB3B'];
        var paths = '';
        for (var i = 0; i < sliceCount; i++) {
            var start = (i * sliceDeg - 90) * Math.PI / 180, end = ((i + 1) * sliceDeg - 90) * Math.PI / 180;
            var x1 = cx + outerR * Math.cos(start), y1 = cy + outerR * Math.sin(start);
            var x2 = cx + outerR * Math.cos(end), y2 = cy + outerR * Math.sin(end);
            var largeArc = sliceDeg > 180 ? 1 : 0;
            paths += '<path d="M ' + cx + ' ' + cy + ' L ' + x1 + ' ' + y1 + ' A ' + outerR + ' ' + outerR + ' 0 ' + largeArc + ' 1 ' + x2 + ' ' + y2 + ' Z" fill="' + colors[i % colors.length] + '" stroke="rgba(255,255,255,0.5)" stroke-width="2"/>';
        }
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' + paths + '</svg>';
        diskStyle = "background-image:url('data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg) + "');background-size:cover;background-position:center;";

        var labelRadius = outerR * 0.62, labelFontSize = isMobile ? 9 : 12, labelWidth = isMobile ? 70 : 90;
        labelsHtml = segs.map(function(s, i) {
            var label = (s.label || ('Dilim ' + (i + 1))).toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\s*-\s*/g, '<br>');
            var midAngleDeg = i * sliceDeg + sliceDeg / 2, midAngleRad = (midAngleDeg - 90) * Math.PI / 180;
            var labelX = cx + labelRadius * Math.cos(midAngleRad), labelY = cy + labelRadius * Math.sin(midAngleRad);
            var color = i % 2 !== 0 ? '#ffffff' : '#111111';
            return '<div class="efxIlLabel" style="left:' + labelX + 'px;top:' + labelY + 'px;color:' + color + ';font-size:' + labelFontSize + 'px;width:' + labelWidth + 'px;transform:translate(-50%,-50%) rotate(' + (midAngleDeg + 90) + 'deg);">' + label + '</div>';
        }).join('');
    }

    var pointerHtml = hasCustomPointer ? '<div class="efxIlPointer efxIlPointerCustom" style="background-image:url(\'' + pointerImageUrl + '\');"></div>' : '<div class="efxIlPointer" style="border-top-color:' + pointerColor + ';"></div>';
    var centerHtml = hasCustomButton ? '<div class="efxIlCenter"><button type="button" class="efxIlCenterBtn efxIlCenterBtnCustom" data-act="spin" style="background-image:url(\'' + buttonImageUrl + '\');"></button></div>' : '<div class="efxIlCenter"><button type="button" class="efxIlCenterBtn" data-act="spin" style="background:linear-gradient(145deg,' + centerBtnBg + ' 0%,' + centerBtnBg + ' 100%);border-color:' + centerBtnBorder + ';color:' + btnText + ';">' + esc(txt('btn_spin')) + '</button></div>';

    // Arka plan görseli (sol panel) — görsel varsa metinler gizlenir (görselde zaten yazı var) ve görsel paneli kaplar
    // Görsel varsa: metinler gizlenir, çark görselin ÜSTÜNDE altta hizalanır (flex-end).
    // Mobilde background-position:top → görselin üst kısmı (yazılar) hep görünür, kırpma
    // alttan olur; çark altta durduğu için yazıların üstüne binmez.
    var leftStyle = backgroundImageUrl ? ' style="background-image:url(\'' + backgroundImageUrl + '\');background-size:cover;background-repeat:no-repeat;justify-content:flex-end;' + (isMobile ? 'background-position:top center;' : 'background-position:center;') + '"' : '';
    var leftHeaderHtml = backgroundImageUrl ? '' : '<div class="efxIlLeftHeader"><span class="efxIlGiftIcon">🎁</span><h2>' + esc(txt('main_title')) + '</h2></div><p class="efxIlSubtitle">' + esc(txt('main_subtitle')) + '</p>';
    // Çark alttan hizalandığında alttan boşluk bırak (desktop 50px, mobil daha az)
    var wheelAreaStyle = backgroundImageUrl ? ' style="margin-bottom:' + (isMobile ? 24 : 50) + 'px;"' : '';

    container.innerHTML = '<div class="efxIlWrap"><div class="efxIlContent"><div class="efxIlLeft" data-section="wheel"' + leftStyle + '>' + leftHeaderHtml + '<div class="efxIlWheelArea"' + wheelAreaStyle + '>' + pointerHtml + '<div class="efxIlStage" style="width:' + size + 'px;height:' + size + 'px;"><div class="efxIlDisk ' + (hasCustomImage ? 'efxIlDiskCustom' : '') + '" id="efxIlDisk" style="' + diskStyle + '">' + labelsHtml + '</div>' + centerHtml + '<div class="efxIlWinOverlay" data-el="winBanner" style="display:none;"><div class="efxIlWinContent"><span class="efxIlWinIcon">🎉</span><span class="efxIlWinLabel">' + esc(txt('win_label')) + '</span><strong data-el="winReward" class="efxIlWinReward"></strong></div></div></div></div></div><div class="efxIlRight ' + (isMobile ? 'efxIlHiddenMobile' : '') + '" data-section="form"><div class="efxIlMobileWinBanner" data-el="mobileWinBanner"><span class="efxIlMobileWinIcon">🎉</span><div class="efxIlMobileWinText"><span>' + esc(txt('win_mobile_prefix')) + '</span><strong data-el="mobileWinReward"></strong></div></div><h2>' + esc(txt('form_title')) + '</h2><p class="efxIlFormSubtitle">' + esc(txt('form_subtitle')) + '</p><div class="efxIlFormArea"><div class="efxIlInputGroup"><label><span class="efxIlInputIcon">✉</span> ' + esc(txt('label_email')) + '</label><input type="email" data-el="emailInput" placeholder="' + esc(txt('placeholder_email')) + '" class="efxIlInput" required></div><div class="efxIlInputGroup"><label><span class="efxIlInputIcon">📱</span> ' + esc(txt('label_phone')) + '</label><div class="efxIlPhoneWrap"><span class="efxIlPhonePrefix">' + esc(txt('phone_prefix')) + '</span><input type="tel" data-el="phoneInput" placeholder="' + esc(txt('placeholder_phone')) + '" class="efxIlInput efxIlPhoneInput" maxlength="10" required></div></div><div class="efxIlCheckboxes"><div class="efxIlCheckboxRow"><label>' + txtP('checkbox_kvkk_info') + '</label></div><div class="efxIlCheckboxRow"><input type="checkbox" id="efxIlMarketing" data-el="marketing"><label for="efxIlMarketing">' + txtP('checkbox_marketing') + '</label></div><div class="efxIlCheckboxRow"><input type="checkbox" id="efxIlMembership" data-el="membership" required><label for="efxIlMembership">' + txtP('checkbox_membership') + '</label></div><div class="efxIlCheckboxRow"><input type="checkbox" id="efxIlConsent" data-el="consent" required><label for="efxIlConsent">' + txtP('checkbox_consent') + '</label></div></div><button type="button" class="efxIlSubmitBtn" data-act="sendSms">' + esc(txt('btn_submit_before_spin')) + '</button><div data-el="formError" class="efxIlError"></div></div><div class="efxIlSmsArea" data-section="sms" style="display:none;"><h3>' + esc(txt('sms_title')) + '</h3><p class="efxIlSmsInfo">' + esc(txt('sms_info')) + '</p><input type="text" data-el="smsCode" class="efxIlSmsInput" maxlength="6" placeholder="' + esc(txt('sms_placeholder')) + '" inputmode="numeric"><div class="efxIlSmsActions"><button type="button" data-act="verifySms" class="efxIlSubmitBtn">' + esc(txt('btn_verify')) + '</button><button type="button" data-act="resendSms" class="efxIlResendBtn">' + esc(txt('btn_resend')) + '</button></div><div data-el="smsError" class="efxIlError"></div><div data-el="smsSuccess" class="efxIlSuccess"></div></div><div class="efxIlCodeArea" data-section="code" style="display:none;"><div class="efxIlCodeSuccess"><span class="efxIlSuccessIcon">🎉</span><h3>' + esc(txt('win_congrats')) + '</h3><p data-el="rewardText"></p></div><div class="efxIlCodeBox"><span data-el="finalCode" class="efxIlFinalCode"></span><button type="button" data-act="copyCode" class="efxIlCopyBtn">' + esc(txt('btn_copy')) + '</button></div><div data-el="copyMsg" class="efxIlCopyMsg">' + esc(txt('copy_success')) + '</div></div></div></div></div>';

    container.style.setProperty('--efx-accent', accent);
    container.style.setProperty('--efx-accent-hover', accentHover);
    container.style.setProperty('--efx-accent-rgb', accentRgb);
    container.style.setProperty('--efx-btn-text', btnText);
    container.style.setProperty('--efx-center-btn-bg', centerBtnBg);
    container.style.setProperty('--efx-center-btn-border', centerBtnBorder);
    container.style.setProperty('--efx-pointer-color', pointerColor);
    container.style.setProperty('--efx-win-reward', winRewardColor);
    container.style.setProperty('--efx-success', successColor);
    container.style.setProperty('--efx-error', errorColor);

    var formSubmitted = false;
    var root = container;
    var leftSection = root.querySelector('.efxIlLeft');
    var rightSection = root.querySelector('.efxIlRight');

    // Mobilde sol panel yüksekliğini görselin gerçek en-boy oranına göre ayarla
    // (vh yerine genişliğe bağlı → her cihazda tutarlı, görsel kırpılmadan görünür).
    if (backgroundImageUrl && isMobile && leftSection) {
        var applyLeftHeight = function() {
            var bgImg = new Image();
            bgImg.onload = function() {
                if (!bgImg.naturalWidth || !bgImg.naturalHeight) return;
                var ratio = bgImg.naturalHeight / bgImg.naturalWidth;
                var w = leftSection.clientWidth;
                if (!w) return;
                // Panel = görselin tam yüksekliği ama en az çark + üstte yazı için yer
                // (size+200). Görsel kısaysa cover alttan kırpar, üstteki yazı görünür kalır.
                var imgH = Math.round(w * ratio);
                leftSection.style.minHeight = Math.max(imgH, size + 200) + 'px';
            };
            bgImg.src = backgroundImageUrl;
        };
        applyLeftHeight();
        window.addEventListener('resize', applyLeftHeight);
    }

    if (blockedReason) {
        dbgWarn('🚫 ENGEL → reason: ' + blockedReason);
        injectTimerCSS();
        var remainingMs = getRemainingMs(blockedReason, ipExpiryMs);
        if (remainingMs > 1000) {
            var endTimeMs = Date.now() + remainingMs;
            if (rightSection) { rightSection.innerHTML = buildTimerHtml(remainingMs, T); rightSection.style.display = ''; rightSection.classList.remove('efxIlHiddenMobile'); }
            if (isMobile && leftSection) { leftSection.classList.add('efxIlHiddenMobile'); }
            var wheelArea = root.querySelector('.efxIlWheelArea');
            if (wheelArea) { wheelArea.style.opacity = '0.4'; wheelArea.style.pointerEvents = 'none'; wheelArea.style.filter = 'blur(2px)'; }
            var btnSpinBlocked = root.querySelector('.efxIlCenterBtn[data-act="spin"]');
            if (btnSpinBlocked) btnSpinBlocked.disabled = true;
            startTimerCountdown(rightSection, endTimeMs, T);
        }
        return;
    }

    dbgOk('🎉 Engel yok, çark aktif!');

    var btnSpinCenter = root.querySelector('.efxIlCenterBtn[data-act="spin"]');
    var diskEl = root.querySelector('#efxIlDisk');
    var formArea = root.querySelector('.efxIlFormArea');
    var smsArea = root.querySelector('.efxIlSmsArea');
    var codeArea = root.querySelector('.efxIlCodeArea');
    var spinning = false, currentDeg = 0, spinLocked = false, pendingResult = null;
    var emailInput = root.querySelector('[data-el="emailInput"]');
    var phoneInput = root.querySelector('[data-el="phoneInput"]');
    var marketingCheck = root.querySelector('[data-el="marketing"]');
    var membershipCheck = root.querySelector('[data-el="membership"]');
    var consentCheck = root.querySelector('[data-el="consent"]');
    var formError = root.querySelector('[data-el="formError"]');
    var submitBtn = root.querySelector('[data-act="sendSms"]');

    phoneInput.addEventListener('input', function(e) { var val = e.target.value.replace(/\D/g, ''); if (val.startsWith('0')) val = val.substring(1); if (val.length > 10) val = val.substring(0, 10); e.target.value = val; });

    function buildRewardText(seg) {
        var rewardText = (seg && seg.label) || 'Ödül';
        var rt = seg && seg.rewardType, rv = seg && seg.rewardValue;
        if (rt === 'free_shipping') rewardText = txt('reward_free_shipping');
        else if (rt === 'fixed_amount') rewardText = (rv || '') + ' ' + txt('reward_fixed_amount_suffix');
        else if (rt === 'percent') rewardText = txt('reward_percent_prefix') + (rv || '') + ' ' + txt('reward_percent_suffix');
        return rewardText;
    }

    async function doSpin() {
        dbg('🎰 doSpin() → spinning: ' + spinning + ', spinLocked: ' + spinLocked);
        if (spinning || spinLocked || !segs.length) return;
        btnSpinCenter.disabled = true;
        var ipCheck = await checkIpSpin(wheel && wheel.id);
        if (!ipCheck.allowed) { blockedReason = 'ip_blocked'; window.location.reload(); return; }
        spinning = true;
        markWheelSpun();
        var picked = pickWeighted(segs);
        dbg('🎰 Seçilen segment → index: ' + picked.index + ', label: ' + (picked.seg && picked.seg.label));
        var centerAngle = picked.index * sliceDeg + sliceDeg / 2;
        var extraTurns = 5;
        var jitter = (Math.random() - 0.5) * (sliceDeg * 0.6);
        var targetDeg = extraTurns * 360 + (360 - centerAngle) + jitter;
        currentDeg = ((currentDeg % 360) + 360) % 360;
        var finalDeg = Math.floor(currentDeg / 360) * 360 + targetDeg;
        diskEl.style.transform = 'rotate(' + finalDeg + 'deg)';
        currentDeg = finalDeg;

        setTimeout(async function() {
            spinning = false;
            showConfetti();
            var apiRes = await sendToProxy({ action: 'wheelSpinResult', wheelId: (wheel && wheel.id) || null, source: WHEEL_SOURCE, segmentIndex: picked.index, segmentId: (picked.seg && picked.seg.id) || null, label: (picked.seg && picked.seg.label) || null, rewardType: (picked.seg && picked.seg.rewardType) || null, rewardValue: (picked.seg && picked.seg.rewardValue) || null, ts: Date.now() });
            if (apiRes && apiRes.ok) {
                dbgOk('🎰 Spin başarılı → resultId: ' + apiRes.result_id);
                var rewardText = buildRewardText(picked.seg);
                pendingResult = { resultId: apiRes.result_id, wheelId: (wheel && wheel.id) || null, segmentIndex: picked.index, rewardText: rewardText };
                root.querySelector('[data-el="winBanner"]').style.display = 'flex';
                root.querySelector('[data-el="winReward"]').textContent = rewardText;
                submitBtn.textContent = txt('btn_submit_after_spin');
                if (isMobile) { setTimeout(function() { var mobileWinReward = root.querySelector('[data-el="mobileWinReward"]'); if (mobileWinReward) mobileWinReward.textContent = rewardText; leftSection.classList.add('efxIlHiddenMobile'); rightSection.classList.remove('efxIlHiddenMobile'); container.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 1500); }
                spinLocked = true;
                btnSpinCenter.style.display = 'none';
            } else { dbgWarn('🎰 Spin başarısız', apiRes); }
        }, 2000);
    }

    btnSpinCenter.addEventListener('click', doSpin);

    submitBtn.addEventListener('click', async function() {
        dbg('📝 Submit tıklandı');
        if (!pendingResult) { doSpin(); return; }
        var email = (emailInput.value || '').trim();
        var phone = (phoneInput.value || '').replace(/\D/g, '');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { formError.textContent = txt('error_email'); formError.style.display = 'block'; return; }
        if (!phone || phone.length !== 10 || !/^5\d{9}$/.test(phone)) { formError.textContent = txt('error_phone'); formError.style.display = 'block'; return; }
        if (!membershipCheck.checked) { formError.textContent = txt('error_membership'); formError.style.display = 'block'; return; }
        if (!consentCheck.checked) { formError.textContent = txt('error_consent'); formError.style.display = 'block'; return; }
        formError.style.display = 'none';
        submitBtn.disabled = true;
        submitBtn.textContent = txt('btn_submitting');
        var res = await sendToProxy({ action: 'sendVerificationSms', resultId: pendingResult.resultId, source: WHEEL_SOURCE, email: email, phone: phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex, marketing: marketingCheck.checked });
        if (res && res.ok) {
            dbgOk('📝 SMS gönderildi → smsId: ' + res.sms_id);
            formSubmitted = true;
            pendingResult.email = email; pendingResult.phone = phone; pendingResult.smsId = res.sms_id || null;
            formArea.style.display = 'none'; smsArea.style.display = 'flex';
            var rightH2 = root.querySelector('.efxIlRight h2'), formSubtitle = root.querySelector('.efxIlFormSubtitle');
            if (rightH2) rightH2.style.display = 'none';
            if (formSubtitle) formSubtitle.style.display = 'none';
        } else {
            dbgWarn('📝 SMS gönderilemedi', res);
            formError.textContent = (res && res.error) || txt('error_sms_send'); formError.style.display = 'block';
            submitBtn.disabled = false; submitBtn.textContent = txt('btn_submit_after_spin');
        }
    });

    var smsCodeInput = root.querySelector('[data-el="smsCode"]');
    var verifyBtn = root.querySelector('[data-act="verifySms"]');
    var resendBtn = root.querySelector('[data-act="resendSms"]');
    var smsError = root.querySelector('[data-el="smsError"]');
    var smsSuccess = root.querySelector('[data-el="smsSuccess"]');

    smsCodeInput.addEventListener('input', function(e) { e.target.value = e.target.value.replace(/\D/g, '').substring(0, 6); });

    verifyBtn.addEventListener('click', async function() {
        var code = (smsCodeInput.value || '').trim();
        dbg('🔐 SMS doğrulama → kod: ' + code);
        if (!code || code.length !== 6) { smsError.textContent = txt('error_sms_code'); smsError.style.display = 'block'; return; }
        smsError.style.display = 'none'; verifyBtn.disabled = true; verifyBtn.textContent = txt('btn_verifying');
        var res = await sendToProxy({ action: 'verifySmsCode', resultId: pendingResult.resultId, source: WHEEL_SOURCE, smsId: pendingResult.smsId, code: code, email: pendingResult.email, phone: pendingResult.phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex });

        if (res && res.error_type === 'phone_conflict') {
            dbgWarn('🔐 Telefon çakışması!', res);
            smsArea.style.display = 'none'; codeArea.style.display = 'flex';
            if (isMobile) { var mobileWinBanner = root.querySelector('[data-el="mobileWinBanner"]'); if (mobileWinBanner) mobileWinBanner.style.display = 'none'; }
            var codeSuccess = codeArea.querySelector('.efxIlCodeSuccess'), codeBox = codeArea.querySelector('.efxIlCodeBox'), copyMsg = codeArea.querySelector('[data-el="copyMsg"]');
            if (codeSuccess) codeSuccess.style.display = 'none'; if (codeBox) codeBox.style.display = 'none'; if (copyMsg) copyMsg.style.display = 'none';
            showPhoneConflictWarning(res.error);
            return;
        }
        if (res && res.ok && res.code) {
            dbgOk('🔐 Doğrulama başarılı → kod: ' + res.code);
            markWheelUsed();
            showFinalCode(pendingResult.rewardText, res.code);
        } else {
            dbgWarn('🔐 Doğrulama başarısız', res);
            smsError.textContent = (res && res.error) || txt('error_sms_verify'); smsError.style.display = 'block';
            var criticalErrors = ['kod kalmadı', 'Maksimum', 'limiti aşıldı', 'bulunamadı'];
            if (criticalErrors.some(function(err) { return ((res && res.error) || '').toLowerCase().indexOf(err.toLowerCase()) !== -1; })) { verifyBtn.disabled = true; verifyBtn.textContent = txt('btn_completed'); resendBtn.disabled = true; smsCodeInput.disabled = true; }
            else { verifyBtn.disabled = false; verifyBtn.textContent = txt('btn_verify'); smsCodeInput.value = ''; smsCodeInput.focus(); }
        }
    });

    resendBtn.addEventListener('click', async function() {
        dbg('📱 SMS tekrar gönder');
        resendBtn.disabled = true; resendBtn.textContent = txt('btn_submitting'); smsError.style.display = 'none';
        var res = await sendToProxy({ action: 'sendVerificationSms', resultId: pendingResult.resultId, source: WHEEL_SOURCE, email: pendingResult.email, phone: pendingResult.phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex, resend: true });
        if (res && res.ok) {
            dbgOk('📱 SMS tekrar gönderildi');
            pendingResult.smsId = res.sms_id || null;
            smsSuccess.textContent = txt('sms_success'); smsSuccess.style.display = 'block';
            setTimeout(function() { smsSuccess.style.display = 'none'; }, 3000);
            resendBtn.disabled = false; resendBtn.textContent = txt('btn_resend');
        } else {
            dbgWarn('📱 SMS tekrar gönderilemedi', res);
            var criticalErrors = ['Maksimum', 'limiti aşıldı', 'hakkınızı kullandınız'];
            if (criticalErrors.some(function(err) { return ((res && res.error) || '').toLowerCase().indexOf(err.toLowerCase()) !== -1; })) { smsError.textContent = (res && res.error) || txt('error_sms_send'); smsError.style.display = 'block'; resendBtn.disabled = true; resendBtn.textContent = txt('btn_limit_exceeded'); }
            else { smsError.textContent = (res && res.error) || txt('error_sms_send'); smsError.style.display = 'block'; resendBtn.disabled = false; resendBtn.textContent = txt('btn_resend'); }
        }
    });

    smsCodeInput.addEventListener('keypress', function(e) { if (e.key === 'Enter') verifyBtn.click(); });

    function showFinalCode(rewardText, code) {
        smsArea.style.display = 'none'; codeArea.style.display = 'flex';
        if (isMobile) { var mobileWinBanner2 = root.querySelector('[data-el="mobileWinBanner"]'), rightH2b = root.querySelector('.efxIlRight h2'), formSubtitleB = root.querySelector('.efxIlFormSubtitle'); if (mobileWinBanner2) mobileWinBanner2.style.display = 'none'; if (rightH2b) rightH2b.style.display = 'none'; if (formSubtitleB) formSubtitleB.style.display = 'none'; }
        root.querySelector('[data-el="rewardText"]').textContent = rewardText;
        root.querySelector('[data-el="finalCode"]').textContent = code;
        var copyBtn = root.querySelector('[data-act="copyCode"]'), copyMsgEl = root.querySelector('[data-el="copyMsg"]');
        copyBtn.addEventListener('click', async function() { try { await navigator.clipboard.writeText(code); copyMsgEl.style.display = 'block'; copyBtn.textContent = txt('btn_copied'); copyBtn.disabled = true; } catch (e) { } });
    }

    function showPhoneConflictWarning(message) {
        var warningDiv = document.createElement('div');
        warningDiv.className = 'efxIlPhoneConflict';
        warningDiv.innerHTML = '<div class="efxIlConflictIcon">⚠️</div><h3 style="margin:10px 0;color:#c0392b;">İşlem Tamamlanamadı</h3><p class="efxIlConflictText">' + (message || txt('phone_conflict_message')) + '</p><a href="' + txt('url_support') + '" target="_blank" rel="noopener noreferrer" class="efxIlConflictBtn">' + txt('support_link_text') + '</a>';
        codeArea.appendChild(warningDiv);
    }

    function showConfetti() {
        var old = document.getElementById('efxIlConfettiWrap'); if (old) old.remove();
        var wrap = document.createElement('div'); wrap.id = 'efxIlConfettiWrap';
        wrap.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999999;overflow:hidden;';
        if (!document.getElementById('efxIlConfettiCSS')) { var css = document.createElement('style'); css.id = 'efxIlConfettiCSS'; css.textContent = '@keyframes efxIlDrop{0%{top:-5%;opacity:1}100%{top:105%;opacity:0.8}}@keyframes efxIlSwing{0%,100%{margin-left:0}50%{margin-left:25px}}@keyframes efxIlTwist{0%{transform:rotate3d(1,1,0,0deg)}100%{transform:rotate3d(1,1,0,360deg)}}'; document.head.appendChild(css); }
        var confettiColors = ['#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6', '#1abc9c', '#e91e63', '#00bcd4', '#ffeb3b', '#ff5722'];
        for (var i = 0; i < 80; i++) { var p = document.createElement('div'); var c = confettiColors[Math.floor(Math.random() * confettiColors.length)]; var x = Math.random() * 100, w = 7 + Math.random() * 6, h = 10 + Math.random() * 8; var fall = 2.5 + Math.random() * 2.5, swing = 1.5 + Math.random() * 1.5, twist = 1 + Math.random() * 2, delay = Math.random() * 1.5; p.style.cssText = 'position:absolute;left:' + x + '%;top:-5%;width:' + w + 'px;height:' + h + 'px;background:' + c + ';border-radius:2px;animation:efxIlDrop ' + fall + 's linear ' + delay + 's forwards,efxIlSwing ' + swing + 's ease-in-out ' + delay + 's infinite alternate,efxIlTwist ' + twist + 's linear ' + delay + 's infinite;'; wrap.appendChild(p); }
        document.body.appendChild(wrap);
        setTimeout(function() { wrap.remove(); }, 6000);
    }

    if (!blockedReason) { window.addEventListener('beforeunload', function() { if (!formSubmitted && !hasUsedWheel()) { dbg('🚪 Sayfa kapatılıyor → markDismissed()'); markDismissed(); } }); }
}

function preloadImages(wheel) {
    var urls = [wheel.wheel_image, wheel.pointer_image, wheel.button_image, wheel.background_image].filter(Boolean);
    if (urls.length === 0) return Promise.resolve();
    return new Promise(function(resolve) { var loaded = 0, total = urls.length, timeout = setTimeout(resolve, 5000); urls.forEach(function(url) { var img = new Image(); img.onload = img.onerror = function() { loaded++; if (loaded >= total) { clearTimeout(timeout); resolve(); } }; img.src = url; }); });
}

async function init() {
    dbg('🚀 init() başlatılıyor...');
    var container = document.getElementById('efxGwInlineContainer');
    if (!container) { dbgWarn('🚀 #efxGwInlineContainer bulunamadı!'); return; }
    dbgOk('🚀 Container bulundu');

    dbg('🍪 COOKIE DURUMU:');
    var allWheelCookies = document.cookie.split(';').filter(function(c) { return c.indexOf('efx_wheel') !== -1; });
    if (allWheelCookies.length === 0) { dbg('🍪 → Hiç efx_wheel cookie\'si yok'); }
    else { allWheelCookies.forEach(function(c) { dbg('🍪 → ' + c.trim()); }); }

    var blockedReason = null;
    if (hasUsedWheel()) { blockedReason = 'used'; }
    else if (hasSpunWheel()) { blockedReason = 'spun'; }
    else if (hasBeenDismissed()) { blockedReason = 'dismissed'; }

    container.innerHTML = '<div class="efxIlLoading"><div class="efxIlSpinner"></div><p>Çark yükleniyor...</p></div>';

    var currentPath = window.location.pathname;
    var res = await sendToProxy({ action: 'getWheels', onlyActive: 1, currentPath: currentPath, pageType: 'gift_wheel' });
    if (!res || !res.ok || !Array.isArray(res.wheels) || res.wheels.length === 0) { container.innerHTML = '<div class="efxIlLoading"><p>Aktif çark bulunamadı.</p></div>'; return; }

    var wheel = res.wheels[0];
    dbgOk('📡 Çark yüklendi → id: ' + wheel.id);

    var ipExpiryMs = null;
    if (!blockedReason) {
        var ipCheck = await checkIpAllowed(wheel.id);
        if (!ipCheck.allowed) {
            blockedReason = 'ip_blocked';
            ipExpiryMs = ipCheck.expires_at || (Date.now() + 24 * 60 * 60 * 1000);
        }
    }

    dbg('📊 SONUÇ → blockedReason: ' + (blockedReason || 'YOK') + ', çark aktif: ' + (!blockedReason ? 'EVET ✅' : 'HAYIR ❌'));

    await preloadImages(wheel);
    renderInline(wheel, blockedReason, ipExpiryMs);
}

init();

})();